/* =============================================
   LE FUMOIR — NAV JS
   Mobile accordion + desktop keyboard nav
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // --- MOBILE HAMBURGER ---
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav    = document.querySelector('.site-header__nav');

  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('site-header__nav--open');
      this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    // Close when a leaf nav link is followed (skip parent links that open an
    // accordion submenu on mobile — those should expand, not close the nav)
    mobileNav.querySelectorAll('a.nav-item__link, .nav-dropdown__link').forEach(link => {
      link.addEventListener('click', () => {
        if (link.closest('.nav-item--has-dropdown') && link.classList.contains('nav-item__link')) {
          return;
        }
        mobileNav.classList.remove('site-header__nav--open');
        mobileMenuBtn.setAttribute('aria-expanded', 'false');
      });
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!mobileMenuBtn.contains(e.target) && !mobileNav.contains(e.target)) {
        mobileNav.classList.remove('site-header__nav--open');
        mobileMenuBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // --- MOBILE ACCORDION TOGGLES ---
  const isMobileNavWidth = function () {
    return window.matchMedia('(max-width: 900px)').matches;
  };

  const toggleMobileDropdown = function (navItem, toggleBtn) {
    const dropdown = navItem.querySelector('.nav-dropdown--mobile');
    if (!dropdown) return;

    const isOpen = dropdown.classList.toggle('open');
    if (toggleBtn) {
      toggleBtn.classList.toggle('open', isOpen);
      toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggleBtn.textContent = isOpen ? '×' : '+';
    }
  };

  document.querySelectorAll('.nav-mobile-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      const navItem = this.closest('.nav-item--has-dropdown');
      if (!navItem) return;
      toggleMobileDropdown(navItem, this);
    });
  });

  // Tapping the menu row (incl. the menu name link) also expands it on mobile,
  // instead of requiring the small "+" to be tapped. Desktop behavior (hover
  // dropdown, normal link navigation) is untouched — this only runs at mobile widths.
  document.querySelectorAll('.nav-item--has-dropdown > .nav-item__link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (!isMobileNavWidth()) return; // desktop: keep normal link behavior

      const navItem = this.closest('.nav-item--has-dropdown');
      if (!navItem) return;
      const dropdown = navItem.querySelector('.nav-dropdown--mobile');
      if (!dropdown) return;

      e.preventDefault();
      e.stopPropagation();
      const toggleBtn = navItem.querySelector('.nav-mobile-toggle');
      toggleMobileDropdown(navItem, toggleBtn);
    });
  });

  // --- KEYBOARD ACCESSIBILITY (desktop dropdowns) ---
  document.querySelectorAll('.nav-item--has-dropdown').forEach(function (item) {
    const link     = item.querySelector('.nav-item__link');
    const dropdown = item.querySelector('.nav-dropdown');

    if (!link || !dropdown) return;

    // Open on Enter/Space when focused
    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const isVisible = dropdown.style.visibility === 'visible' ||
                          getComputedStyle(dropdown).visibility === 'visible';
        if (!isVisible) {
          dropdown.style.opacity    = '1';
          dropdown.style.visibility = 'visible';
          dropdown.style.transform  = 'translateX(-50%) translateY(0)';
          dropdown.querySelector('a')?.focus();
        }
      }
      if (e.key === 'Escape') {
        dropdown.style.opacity    = '';
        dropdown.style.visibility = '';
        dropdown.style.transform  = '';
        link.focus();
      }
    });

    // Close on Escape when inside dropdown
    dropdown.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        dropdown.style.opacity    = '';
        dropdown.style.visibility = '';
        dropdown.style.transform  = '';
        link.focus();
      }
    });
  });

});
